import { Component, OnInit } from "@angular/core";
import { ScrollingService } from "../services/scrolling.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  open: boolean = false;

  constructor(private scrolling: ScrollingService) {}

  ngOnInit() {}

  public get Margin(): string {
    const w = 10.5;
    return `${this.scrolling.index * w}em`;
  }
  public get HasIndex(): boolean {
    return this.scrolling.index > 0;
  }
  close() {
    setTimeout(() => {
      this.open = false;
    }, 20);
  }
}
